import { Entity, type EntityProps } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export interface ScopeProps extends EntityProps {
    description?: string;
    files?: ScopeFile[];
}

export interface ScopeFile {
    id: string;
    fileName: string;
    uploadDate: string;
    base64: string;
}

export class Scope extends Entity implements ScopeProps {
    files: ScopeFile[];
    description?: string;

    constructor({ id, name, description, files }: ScopeProps) {
        super({ id, name });
        this.description = description;
        this.files = Array.isArray(files) ? files : [];
    }

    static new(props: Omit<Omit<ScopeProps, 'id'>, 'files'>): Scope {
        const uuid = new UUID();
        return new Scope({
            id: uuid.toString(),
            files: [],
            ...props,
        });
    }
}
